import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { ignoreCancelledRequests } from '@/lib/ignoreCancelledRequests'

// Registered before anything renders: a request the browser cancels (map tiles
// released on teardown, a page left mid-load) is normal browsing, not an error.
ignoreCancelledRequests()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)

// Offline support: the app shell, opened pages and seen photos stay available
// without a connection. Only the published site registers it — never the
// builder preview or an embedded frame, where it would hold back live edits.
if (
  'serviceWorker' in navigator &&
  import.meta.env.PROD &&
  window.self === window.top
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}